import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		rowWrapper:
			'flex flex-col rounded-l lg:rounded-none lg:grid grid-cols-6 col-span-6 gap-x-4 lg:items-center px-2 lg:px-0 py-2 border lg:border-r-0 lg:border-l-0 lg:border-b-0 lg:border-t border-black',
		title: 'col-span-3 lg:!font-helvetica lg:!text-s lg:!normal-case',
		description: 'order-1 mt-[0.5rem] lg:mt-0 lg:order-none hidden',
		icons: 'order-2 mt-1 lg:mt-0 lg:order-none flex gap-[0.6rem] col-span-2',
		iconWrapper: 'flex items-center justify-center rounded-full h-[2.4rem] w-[2.4rem]',
	},
})

export type InformationRowVariants = VariantProps<typeof styles>
